import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Container, PageTitle, NbCard, Chip } from "@/components/nb";
import { Stagger, Item } from "@/components/motion";
import { ArrowRight, Search } from "lucide-react";

export default function SkillsHub() {
  const [tracks, setTracks] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/skills/tracks").then((r) => setTracks(r.data)); }, []);
  const filtered = useMemo(() => {
    const query = q.trim().toLowerCase();
    if (!query) return tracks;
    return tracks.filter((t) => (t.title || "").toLowerCase().includes(query) || (t.description || "").toLowerCase().includes(query));
  }, [tracks, q]);
  return (
    <Container>
      <PageTitle eyebrow="SKILL DEVELOPMENT" title="The stuff school forgets." sub="Curated video lessons from top teachers + hands-on projects." />
      <div className="flex items-center gap-3 bg-white nb-border nb-shadow rounded-xl px-4 py-3 max-w-xl mb-6">
        <Search className="w-5 h-5 shrink-0" />
        <input data-testid="skills-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search a skill..." className="flex-1 bg-transparent outline-none py-1" />
        {q && <button onClick={() => setQ("")} data-testid="clear-skills" className="font-mono-sl text-[10px] uppercase underline">Clear</button>}
      </div>
      <Stagger className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="tracks">
        {filtered.length === 0 && <div className="text-neutral-500">No tracks match your search.</div>}
        {filtered.map((t) => (
          <Item key={t.id}>
            <Link to={`/skills/${t.id}`} data-testid={`track-${t.id}`} className="block h-full">
              <NbCard color={t.color} className="nb-hover-lg min-h-[200px] h-full">
                <Chip color="accent">{t.lessons.length} LESSONS · {t.projects.length} PROJECTS</Chip>
                <div className="mt-3 flex justify-between items-center">
                  <h3 className="font-heading font-black text-3xl tracking-tighter">{t.title}</h3>
                  <ArrowRight className="w-6 h-6" />
                </div>
                <p className="mt-2 text-neutral-800">{t.description}</p>
              </NbCard>
            </Link>
          </Item>
        ))}
      </Stagger>
    </Container>
  );
}
